import { slideUp, slideDown } from 'es6-slide-up-down'
import{ easeInOutCubic } from 'es6-easings'
import Swiper from 'swiper'

import store from '@js/modules/store'
import Slides from '@js/libs/Slides'
import Swipino from '@js/libs/Swipino'
import Feedizi from '@js/libs/Feedizi'
import Realizations from '@js/libs/Realizations'

// TODO : changer le comportement swipe des sliders, plus réactifs sur mobile

// Accordion
export const accordion = block => {
    // Appearance
    if(window.innerWidth >= 1024) {
        block.querySelectorAll('.m-accordion_title').forEach(accordionTitle => {
            store.animizi.addAccordion(accordionTitle)
        })
    }
    // Content appear on title click
    const accordion = block.querySelector('.m-accordion')
    const titles = accordion.querySelectorAll('.m-accordion_title')
    let opened = false
    titles.forEach(title => {
        const item = title.parentNode
        title.addEventListener('click', () => {
            // Opened goes up
            if(opened !== false) {
                slideUp(opened.querySelector('.m-accordion_content'), {
                    duration: 750,
                    easing: easeInOutCubic
                })
                opened.classList.remove('-opened')
            }
            // New
            if(opened !== item) {
                slideDown(item.querySelector('.m-accordion_content'), {
                    duration: 750,
                    easing: easeInOutCubic
                })
                item.classList.add('-opened')
                opened = item
            }  else if(opened == item) {
                opened = false
            }
        })
    })
}

// Addresses
export const addresses = block => {
    // Appearance
    if(window.innerWidth >= 1024) {
        block.querySelectorAll('.m-addresses_title').forEach(title => {
            store.animizi.addHeading2bis(title)
        })
    }
    // Address appear on title click
    const addresses = block.querySelector('.m-addresses')
    const titles = addresses.querySelectorAll('.m-addresses_title')
    // Open the first one
    let opened = addresses.querySelector('.m-addresses_address:first-child')
    slideDown(opened.querySelector('.m-addresses_content'), { duration: 0 })
    // Title click
    titles.forEach(title => {
        const item = title.parentNode
        title.addEventListener('click', () => {
            // Opened goes up
            if(opened !== false) {
                slideUp(opened.querySelector('.m-addresses_content'), {
                    duration: 500,
                    easing: easeInOutCubic
                })
                opened.classList.remove('-opened')
            }
            // New
            if(opened !== item) {
                slideDown(item.querySelector('.m-addresses_content'), {
                    duration: 500,
                    easing: easeInOutCubic
                })
                item.classList.add('-opened')
                opened = item
            }
        })
    })
}

// Gallery
export const gallery = block => {
    // Mobile
    const gallery = block.querySelector('.m-gallery_container')
    const gallerySwiper = new Swiper(gallery, {
        speed: 750,
        slidesPerView: 'auto',
        spaceBetween: 20,
        freeMode: true,
        grabCursor: true,
        breakpoints: {
            768: {
                loop: true,
                freeMode: false,
                centeredSlides: true,
                spaceBetween: 40
            }
        }
    })
    // Desktop behaviour
    if(window.innerWidth >= 1024) {
        // Appearance
        if(block.querySelector('.a-heading.-h2-2'))
            store.animizi.addHeading2(block.querySelector('.a-heading.-h2-2'))
        // Gallery swiper
        block.querySelector('.m-gallery_arrow.-next').addEventListener('click', () => {
            gallerySwiper.slideNext()
        })
        block.querySelector('.m-gallery_arrow.-prev').addEventListener('click', () => {
            gallerySwiper.slidePrev()
        })
    }
}

// Markets
export const markets = block => {
    // Appearance
    if(window.innerWidth >= 1024) {
        block.querySelectorAll('.m-markets_market').forEach(market => {
            store.animizi.addMarket(market)
        })
    }
    // Slides
    const markets = block.querySelector('.m-markets')
    if(window.innerWidth >= 1024 && markets) {
        const slides = new Slides(block.querySelector('.a-slides.-markets'))
        // Listen markets hover
        markets.querySelectorAll('.m-markets_link').forEach(marketLink => {
            marketLink.addEventListener('mouseover', () => {
                if(!marketLink.parentNode.classList.contains('-active')) {
                    // Switch active market classes
                    if(markets.querySelector('.m-markets_market.-active'))
                        markets.querySelector('.m-markets_market.-active').classList.remove('-active')
                        marketLink.parentNode.classList.add('-active')
                    // Swipe to hovered industry slide
                    slides.slideTo(marketLink.parentNode.dataset.slide)
                }
            })
        })
    }
}

// Realizations
export const realizations = block => {
    // Desktop behaviour
    if(window.innerWidth >= 1024) {
        // Appearance
        block.querySelectorAll('.m-view-realizations_bloc_row').forEach(realization => {
            store.animizi.addRealization(realization)
        })
        // Slides
        const realizations = block.querySelector('.m-view-realizations_bloc')
        const slides = new Slides(block.querySelector('.a-slides.-realizations'))
        // Slide to second if we have 3 realizations
        if(slides.swiper.slides.length == 3)
            slides.slideTo(1)
        // Listen markets hover
        realizations.querySelectorAll('.m-view-realizations_bloc_link').forEach(realizationLink => {
            realizationLink.addEventListener('mouseover', () => {
                if(!realizationLink.parentNode.classList.contains('-active')) {
                    // Switch active market classes
                    if(realizations.querySelector('.m-view-realizations_bloc_row.-active'))
                        realizations.querySelector('.m-view-realizations_bloc_row.-active').classList.remove('-active')
                        realizationLink.parentNode.classList.add('-active')
                    // Slide to hovered industry slide
                    slides.slideTo(realizationLink.parentNode.dataset.slide)
                }
            })
        })
    }
    // Mobile behaviour
    new Swipino(block.querySelector('.m-view-realizations_bloc_rows'), {
        slideClass: 'm-view-realizations_bloc_row',
        breakpoint: 1024,
        options: {
            speed: 400,
            slidesPerView: 'auto',
            spaceBetween: 20,
            freeMode: true
        }
    })
}

// Team
export const team = block => {
    // Desktop behaviour
    if(window.innerWidth >= 1024) {
        if(block.querySelector('.a-heading.-h2-2'))
            store.animizi.addHeading2(block.querySelector('.a-heading.-h2-2'))
    }
    // Mobile behaviour
    new Swipino(block.querySelector('.m-cards'), {
        slideClass: 'm-cards_card',
        breakpoint: 1024,
        options: {
            speed: 400,
            slidesPerView: 'auto',
            spaceBetween: 20,
            freeMode: true
        }
    })
}

// Blog
export const blog = block => {
    new Swipino(block.querySelector('.m-teasers'), {
        slideClass: 'm-teasers_teaser',
        breakpoint: 1024,
        options: {
            speed: 400,
            slidesPerView: 'auto',
            freeMode: true,
            spaceBetween: 0
        }
    })
}

// Cards
export const cards = block => {
    new Swipino(block.querySelector('.m-cards'), {
        slideClass: 'm-cards_card',
        breakpoint: 1024,
        options: {
            speed: 400,
            slidesPerView: 'auto',
            spaceBetween: 16,
            freeMode: true
        }
    })
}

// Text Image
export const textImage = block => {
    if(window.innerWidth >= 1024) {
        if(block.querySelector('.a-heading.-h2-2'))
            store.animizi.addHeading2(block.querySelector('.a-heading.-h2-2'))
    }
}

// Text
export const text = block => {
    if(window.innerWidth >= 1024) {
        if(block.querySelector('.a-heading.-h2-2'))
            store.animizi.addHeading2(block.querySelector('.a-heading.-h2-2'))
        if(block.querySelector('.a-text.-fatter'))
            store.animizi.addText(block.querySelector('.a-text.-fatter'))
    }
}

// Key Figures
export const keyFigures = block => {
    if(window.innerWidth >= 1024) {
        store.animizi.addHeading2(block.querySelector('.a-heading.-h2-2'))
        block.querySelectorAll('.m-keyFigures_item').forEach(title => {
            store.animizi.addKeyFigures(title)
        })
    }
}

// Button
export const button = block => {
    if(window.innerWidth >= 1024) {
        if(block.querySelector('.a-heading.-h2'))
            store.animizi.addHeading2bis(block.querySelector('.a-heading.-h2'))
    }
}

// Factory
export const factory = block => {
    if(window.innerWidth >= 1024) {
        if(block.querySelector('.a-heading.-h2-2'))
            store.animizi.addHeading2(block.querySelector('.a-heading.-h2-2'))
        block.querySelectorAll('.m-lilCards_card .a-heading.-h4').forEach(title => {
            store.animizi.addHeading2bis(title)
        })
    }
}

// Resources
export const resources = block => {
    if(window.innerWidth >= 1024) {
        if(block.querySelector('.m-resources_top .a-heading.-h3-2'))
            store.animizi.addHeading2(block.querySelector('.m-resources_top .a-heading.-h3-2'))
    }
    // Blog
    const blog = block.querySelector('.m-view-resources_api')
    if(blog) {
        const feedizi = new Feedizi(blog, {
            rowClass: 'm-resources_resource'
        })
        // Put tags in a container, and before promote section
        const tagsBlog = block.querySelector('.m-view-resources_api_tags')
        if(tagsBlog) {
            block.querySelector('.o-block_tags').appendChild(tagsBlog)
        }
    }
}

// Contact
export const contact = block => {
    if(window.innerWidth >= 1024) {
        if(block.querySelector('.a-heading.-h2-2'))
            store.animizi.addHeading2(block.querySelector('.a-heading.-h2-2'))
    }
    // Range input
    const range = block.querySelector('input[type="range"]')
    const output = range.nextSibling
    // Set initial value
    rangeInput()
    // Listen range change
    range.addEventListener('input', rangeInput)
    function rangeInput() {
        // Set progress value
        output.innerHTML = range.value
        // Set percent left position
        const progress = Number((range.value - range.min) * 100 / (range.max - range.min))
        output.style.left = `calc(${progress}% + (${11 - progress * 0.22}px + 1px))`;
    }
    // Hide or show range input
    block.querySelector('.form-item-quantity').style.display = 'none'
    const typeInputs = block.querySelectorAll('input[name="type"]')
    typeInputs.forEach(typeInput => {
        typeInput.addEventListener('change', () => {
            if(block.querySelector('input[value="devis"]').checked) {
                block.querySelector('.form-item-quantity').style.display = 'block'
            } else {
                block.querySelector('.form-item-quantity').style.display = 'none'
            }
        })
    })
}

// Introduction
export const realizationIntoduction = block => {
    if(window.innerWidth >= 1024) {
        if(block.querySelector('.a-heading.-h2-2'))
            store.animizi.addHeading2(block.querySelector('.a-heading.-h2-2'))
    }
}

// Realization
export const realization = block => {
    if(window.innerWidth >= 1024) {
        if(block.querySelector('.a-heading.-h2-2'))
            store.animizi.addHeading2(block.querySelector('.a-heading.-h2-2'))
    }
}

// listRealizations
export const listRealizations = block => {
    // Filters
    const realizations = new Realizations(block.querySelector('.m-realizations'))
    if(window.innerWidth >= 1024) {
        realizations.emitter.on('change', () => {
            initRealizations(block)
        })
        initRealizations(block)
    }
}

function initRealizations(block) {
    const slides = new Slides(block.querySelector('.a-slides'))
    // Listen realizations hover
    block.querySelectorAll('.m-realizations_realization').forEach(realizationLink => {
        realizationLink.addEventListener('mouseover', () => {
            if(!realizationLink.classList.contains('-active')) {
                // Switch active market classes
                if(block.querySelector('.m-realizations_realization.-active'))
                    block.querySelector('.m-realizations_realization.-active').classList.remove('-active')
                    realizationLink.classList.add('-active')
                // Swipe to hovered industry slide
                slides.slideTo(realizationLink.dataset.slide)
            }
        })
    })
    // Animation
    store.animizi.addRealizations(block.querySelector('.m-realizations_visualsLift'))
}

// Customers
export const customers = block => {
    let items = ''
    block.querySelector('.m-customers_list').querySelectorAll('.m-customers_item').forEach(item => {
        items += item.innerHTML
    })
    block.querySelector('.m-customers_up').style.setProperty('--speed', `${items.length / 2}s`)
    block.querySelector('.m-customers_down').style.setProperty('--speed', `${items.length / 2}s`)
}